import { isEmptyValue } from '@/utils/common'
import { Row } from 'antd'
import { chain, orderBy, size } from 'lodash'

interface Props {
  data: any
}

function GlassonBreakdown(props: Props) {
  const sortByMainSizes = (data) => {
    return data.sort((a, b) => {
      return (
        props.data?.sizes?.indexOf(a.size) - props.data?.sizes.indexOf(b.size)
      )
    })
  }

  const percentageDifference = (a, b): Number => {
    if (Number(b) == 0 || Number(a) == 0) {
      return 0
    }
    const difference = Number(b) - Number(a)
    // const avg = (Number(b) + Number(a)) / 2
    return Number(Number((difference / a) * 100).toFixed(2))
  }

  const found = props?.data?.all_sample_sizes.find((item) => item.color)
  const allSampleSizesNew = size(props?.data?.all_sample_sizes)
    ? props?.data?.all_sample_sizes[0].sub_items
    : []
  const allSampleSizes = found
    ? props?.data?.all_sample_sizes
    : allSampleSizesNew
  const groupData = chain(allSampleSizes)
    .groupBy((item) => item.color)
    .map((value, key) => {
      const quantity = sortByMainSizes(
        value?.map((item) => {
          return {
            size: item.size,
            value: Number(item.quantity) ?? 0,
          }
        })
      )
      const availableQty = sortByMainSizes(
        value?.map((item) => {
          return {
            size: item.size,
            value: Number(item?.actualQty) ?? 0,
          }
        })
      )
      const sampleSize = sortByMainSizes(
        value?.map((item) => {
          return {
            size: item.size,
            value: Number(item.sampleSize),
          }
        })
      )
      const qtyDifference = []
      const qtyDifferencePercentage = []
      quantity.forEach((item, index) => {
        const tmpQtyDifference = {
          size: item.size,
          value:
            availableQty[`${index}`]?.value > 0
              ? availableQty[`${index}`]?.value - item.value
              : 0,
        }
        qtyDifference.push(tmpQtyDifference)
        const tmpQtyDiferencePercentage = {
          size: item.size,
          value:
            availableQty[`${index}`]?.value > 0
              ? percentageDifference(
                  Number(item.value) ?? 0,
                  Number(availableQty[`${index}`]?.value) ?? 0
                )
              : 0,
        }
        qtyDifferencePercentage.push(tmpQtyDiferencePercentage)
      })

      return {
        key,
        quantity: quantity,
        availableQty: availableQty,
        sampleSize: sampleSize,
        qtyDifference: qtyDifference,
        qtyDifferencePercentage: qtyDifferencePercentage,
      }
    })
    .value()

  const sumTotalValue = (key) => {
    const result = []
    props.data?.sizes.forEach((size) => {
      const valuebySize = props.data?.all_sample_sizes.filter(
        (item) => item.size == size
      )
      const total = valuebySize.reduce((a, b) => {
        a = a + Number(b[key])
        return a
      }, 0)
      result.push({ size: size, value: total })
    })
    return result
  }

  const sumTotalDifference = () => {
    const resultQty = []
    const resultAvailableQty = []
    props.data?.sizes.forEach((size) => {
      const valuebySize = props.data?.all_sample_sizes.filter(
        (item) => item.size == size
      )
      const total = valuebySize.reduce((a, b) => {
        a = a + Number(b['quantity'])
        return a
      }, 0)
      const totalAvailableQty = valuebySize.reduce((a, b) => {
        a = a + Number(b['actualQty'])
        return a
      }, 0)
      resultQty.push({ size: size, value: total })
      resultAvailableQty.push({ size: size, value: totalAvailableQty })
    })

    const qtyDifference = []
    const qtyDifferencePercentage = []
    resultQty.forEach((item, index) => {
      qtyDifference.push({
        size: item.size,
        value:
          resultAvailableQty[`${index}`]?.value > 0
            ? resultAvailableQty[`${index}`]?.value - item.value
            : 0,
      })
      qtyDifferencePercentage.push({
        size: item.size,
        value:
          resultAvailableQty[`${index}`]?.value > 0
            ? percentageDifference(
                Number(item.value) ?? 0,
                Number(resultAvailableQty[`${index}`]?.value) ?? 0
              )
            : 0,
      })
    })

    return {
      qtyDifference,
      qtyDifferencePercentage,
    }
  }

  const totalValue = {
    key: 'Total',
    quantity: sumTotalValue('quantity'),
    availableQty: sumTotalValue('actualQty'),
    sampleSize: sumTotalValue('sampleSize'),
    qtyDifference: sumTotalDifference().qtyDifference,
    qtyDifferencePercentage: sumTotalDifference().qtyDifferencePercentage,
  }

  groupData.push(totalValue)

  const sumValue = (data) => {
    return data
      .reduce((a, b) => {
        a = a + b.value
        return a
      }, 0)
      .toFixed(1)
  }

  const sumDifference = (sumOrderQty, sumAvQty) => {
    return `${
      Number(sumAvQty) > Number(sumOrderQty)
        ? '+'
        : sumAvQty < sumOrderQty
        ? ''
        : ''
    }${percentageDifference(sumOrderQty, sumAvQty)}`
  }

  const isAboveFivePercent = (value: number, sign) => {
    let boolean = false
    if (!isEmptyValue(sign)) {
      if (value < 0) {
        boolean = value * -1 > 5
      } else {
        boolean = value > 5
      }
    }
    return boolean
  }

  const MappedQuantity = (
    data,
    isDark: boolean,
    sign = '',
    isQtyDifference: boolean
  ) => {
    return data?.map((tmp) => {
      return (
        <div
          key={tmp.size}
          className={`flex-1 value-col text-align-right ${
            isDark ? 'bg-dark' : ''
          }`}
          style={{
            color: isAboveFivePercent(Number(tmp?.value), sign) ? 'red' : '',
          }}
        >
          {isQtyDifference ? (tmp?.value <= 0 ? '' : '+') : ''}
          {!isEmptyValue(sign)
            ? tmp?.value?.toFixed(1)
            : tmp?.value?.toFixed(0)}
          {sign}
        </div>
      )
    })
  }

  return (
    <div className="glasson-qty-breakdown-container">
      <Row className="container-header">
        <div className="fixed-width header">
          <p>Color / Size</p>
        </div>
        <Row className="flex-7">
          <div className="fixed-width header" />
          {orderBy(props.data?.sizes, '', 'desc')?.map((item) => {
            return (
              <div className="flex-1 header text-align-right" key={item}>
                <p>{item}</p>
              </div>
            )
          })}
          <div className="flex-1 header text-align-right">
            <p>Total</p>
          </div>
        </Row>
      </Row>
      <div className="container-value">
        {groupData?.map((item) => {
          console.log('groupData...', groupData)
          return (
            <Row key={item.key} className="page-break-inside">
              <div
                className={`fixed-width header-center ${
                  item.key == 'Total' ? 'bg-dark' : ''
                }`}
              >
                {item.key}
              </div>
              <div className="flex-7">
                <Row className="row-value">
                  <div
                    className={`fixed-width label-qty ${
                      item.key == 'Total' ? 'bg-dark' : ''
                    }`}
                  >
                    Order Qty
                  </div>
                  {MappedQuantity(
                    item?.quantity,
                    item.key == 'Total',
                    '',
                    false
                  )}
                  <div className="flex-1 value-col text-align-right bg-dark bold">
                    {sumValue(item.quantity)}
                  </div>
                </Row>
                <Row className="row-value">
                  <div
                    className={`fixed-width label-qty ${
                      item.key == 'Total' ? 'bg-dark' : ''
                    }`}
                  >
                    Available Qty
                  </div>
                  {MappedQuantity(
                    item?.availableQty,
                    item.key == 'Total',
                    '',
                    false
                  )}
                  <div className="flex-1 value-col text-align-right bg-dark bold">
                    {sumValue(item.availableQty)}
                  </div>
                </Row>
                <Row className="row-value">
                  <div
                    className={`fixed-width label-qty ${
                      item.key == 'Total' ? 'bg-dark' : ''
                    }`}
                  >
                    Sample Size
                  </div>
                  {MappedQuantity(
                    item?.sampleSize,
                    item.key == 'Total',
                    '',
                    false
                  )}
                  <div className="flex-1 value-col text-align-right bg-dark bold">
                    {sumValue(item.sampleSize)}
                  </div>
                </Row>
                <Row className="row-value">
                  <div
                    className={`fixed-width label-qty ${
                      item.key == 'Total' ? 'bg-dark' : ''
                    }`}
                  >
                    Qty Difference
                  </div>
                  {MappedQuantity(
                    item?.qtyDifference,
                    item.key == 'Total',
                    '',
                    true
                  )}
                  <div className="flex-1 value-col text-align-right bg-dark bold">
                    {sumValue(item?.qtyDifference)}
                  </div>
                </Row>
                <Row className="row-value">
                  <div
                    className={`fixed-width label-qty ${
                      item.key == 'Total' ? 'bg-dark' : ''
                    }`}
                  >
                    Qty Difference %
                  </div>
                  {MappedQuantity(
                    item?.qtyDifferencePercentage,
                    item?.key == 'Total',
                    '%',
                    true
                  )}
                  <div
                    className="flex-1 value-col text-align-right bg-dark bold"
                    style={{
                      color: isAboveFivePercent(
                        Number(
                          sumDifference(
                            sumValue(item?.quantity),
                            sumValue(item?.availableQty)
                          )
                        ),
                        '%'
                      )
                        ? 'red'
                        : '',
                    }}
                  >
                    {sumDifference(
                      sumValue(item?.quantity),
                      sumValue(item?.availableQty)
                    )}
                    %
                  </div>
                </Row>
              </div>
            </Row>
          )
        })}
      </div>
    </div>
  )
}

export default GlassonBreakdown
